// Utility functions
export const getCurrentDateTime = (): string => {
    return new Date().toISOString();
};
  
export const getCurrentDateShortString = (): string => {
    const now = new Date();
    const year = now.getFullYear();
    const month = String(now.getMonth() + 1).padStart(2, "0");
    const day = String(now.getDate()).padStart(2, "0");
    return `${year}${month}${day}`;
  };
  
  export const makeid = (length: number): string => {
    let result = "";
    const characters = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
    for (let i = 0; i < length; i++) {
      result += characters.charAt(Math.floor(Math.random() * characters.length));
    }
    return result;
  };
  
  export const generateUniqueClientIdForSurveyResponse = (
    pid: number,
    sid: number,
    uid: number
  ): string => {
    const dtstring = getCurrentDateShortString();
    const randomSeq = makeid(6);
    return `p${pid}_s${sid}_u${uid}_${dtstring}_${randomSeq}`;
  };